import * as poolRestaurantActions from '../actions/poolRestaurants'
import update from 'immutability-helper'

const initialState = {
  restaurantsInPool: [],
  foundRestaurants: {
    data: []
  },
}

export default (state = initialState, action) => {
  switch (action.type) {

  case poolRestaurantActions.REMOVE_RESTAURANT_FROM_POOL:

    return {
      ...state,
      restaurantsInPool: state.restaurantsInPool.filter(i => i.id !== action.restaurantId),

      //if removed restaurant in search results re-enable the add to pool button
      foundRestaurants: {
        ...state.foundRestaurants,
        data: state.foundRestaurants.data.map(item => {
          if (item.id === action.restaurantId)
            return { ...item, addedToPool: false }
          else return item
        })
      }
    }

  case poolRestaurantActions.ADD_RESTAURANT_TO_POOL:
    const addedRestaurant = state.foundRestaurants.data.find(item => item.id === action.restaurantId)

    return {
      ...state,
      foundRestaurants: {
        ...state.foundRestaurants,
        data: state.foundRestaurants.data.map(item => {
          if (item.id === action.restaurantId)
            return { ...item, addedToPool: true }
          else return item
        })
      },
      restaurantsInPool: update(state.restaurantsInPool, { $push: [addedRestaurant] })
    }


  case poolRestaurantActions.SAVE_POOL_RESTAURANTS_REQUESTED:
    return {
      ...state,
      poolId: action.poolId,
      isLoading: true
    }

  case poolRestaurantActions.EDIT_POOL_RESTAURANTS_REQUESTED:
    return {
      ...state,
      restaurantDisplayEditMode: true,
      restaurantsInPool: [...action.restaurants],
    }

  case poolRestaurantActions.EDIT_POOL_RESTAURANTS_DONE:
    return {
      ...state,
      restaurantDisplayEditMode: false,
      foundRestaurants: {
        data: []
      },
    }

  case poolRestaurantActions.POOL_RESTAURANTS_SAVED:
    return {
      ...state,
      isLoading: false,
      restaurantDisplayEditMode: false,
      restaurantsInPool: action.restaurants,
      foundRestaurants: {
        data: []}
    }

  case poolRestaurantActions.SAVE_POOL_RESTAURANTS_ERROR:
    return {
      ...state,
      error: action.error,
      isLoading: false
    }
      
  case poolRestaurantActions.SEARCH_RESTAURANTS_FOR_POOL_REQUESTED:
    return {
      ...state,
      isLoading: true,
    }

  case poolRestaurantActions.RESTAURANTS_FOR_POOL_SEARCHED:
    // mark restaurants that are already in pool as added by setting addedToPool
    let updatedFoundRestaurants = action.foundRestaurants === null ? [] :
      action.foundRestaurants.data.map(item => {
        if (state.restaurantsInPool.find(existingItem => existingItem.id === item.id))
          return { ...item, addedToPool: true }
        else return item
      })

    return {
      ...state,
      message: poolRestaurantActions.RESTAURANTS_FOR_POOL_SEARCHED,
      isLoading: false,
      foundRestaurants: {
        ...state.foundRestaurants,
        data: updatedFoundRestaurants
      }
    }

  case poolRestaurantActions.SEARCH_RESTAURANTS_FOR_POOL_ERROR:
    return {
      ...state,
      error: action.error,
      isLoading: false
    }

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurantsEdit.js